import React, { useState } from 'react';
import { ClickAwayListener, InputAdornment } from '@mui/material';
import { useTheme } from '@mui/material';
import { SystemIcon } from '@monorepo/nova-icons';
import { Tooltip, TooltipPlacement } from '../../../../display/tooltip';
import {
  SearchCloseButton,
  SearchContainer,
  StyledIconButton,
  StyledSearchInput,
} from '../styled';

export interface SearchInputProps {
  onSearch?: (searchValue: string) => void;
  searchValue?: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  onSearch,
  searchValue = '',
}) => {
  const theme = useTheme();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [localSearchValue, setLocalSearchValue] = useState(searchValue);

  const handleSearchClick = () => {
    setIsSearchOpen(true);
  };

  const handleSearchClose = () => {
    setIsSearchOpen(false);
    setLocalSearchValue('');
    onSearch?.('');
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setLocalSearchValue(value);
    onSearch?.(value);
  };

  const handleSearchClickAway = () => {
    if (isSearchOpen) {
      setIsSearchOpen(false);
      setLocalSearchValue('');
      onSearch?.('');
    }
  };

  return (
    <ClickAwayListener onClickAway={handleSearchClickAway}>
      <SearchContainer isExpanded={isSearchOpen}>
        {isSearchOpen ? (
          <StyledSearchInput
            variant="outlined"
            size="small"
            placeholder="Search all values..."
            value={localSearchValue}
            onChange={handleSearchChange}
            autoFocus
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SystemIcon
                    iconName="Search"
                    style={{
                      color: theme.palette.text.main,
                      fontSize: '18px',
                    }}
                    sx={{
                      color: `${theme.palette.text.main} !important`,
                      fontSize: '18px',
                      '& svg, & svg *, & path, & circle, & rect': {
                        stroke: `${theme.palette.text.main} !important`,
                        fill: `${theme.palette.text.main} !important`,
                        color: `${theme.palette.text.main} !important`,
                      },
                    }}
                  />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <SearchCloseButton onClick={handleSearchClose}>
                    <SystemIcon
                      iconName="X"
                      style={{
                        color: theme.palette.text.main,
                        fontSize: '14px',
                      }}
                    />
                  </SearchCloseButton>
                </InputAdornment>
              ),
            }}
          />
        ) : (
          <Tooltip title="Search" placement={TooltipPlacement.Top}>
            <StyledIconButton onClick={handleSearchClick}>
              <SystemIcon
                iconName="Search"
                style={{
                  color: theme.palette.text.main,
                  fontSize: '18px',
                }}
              />
            </StyledIconButton>
          </Tooltip>
        )}
      </SearchContainer>
    </ClickAwayListener>
  );
};
